import { getCookie } from './cookies';

interface SendLeadParams {
  eventId: string;
  phone: string;
  name?: string;
  location: string;
  consultationType?: string;
  contentName: string;
}

export const sendLeadToCapi = (params: SendLeadParams): void => {
  fetch('https://peetsunbae.com/api/meta-capi/lead', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      eventId: params.eventId,
      phone: params.phone,
      name: params.name,
      location: params.location,
      consultationType: params.consultationType,
      contentName: params.contentName,
      eventSourceUrl: window.location.href,
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      userAgent: navigator.userAgent,
    }),
  }).catch((error) => {
    console.error('[Meta CAPI] Failed to send to peetsunbae.com:', error);
  });
};

interface SendAttributionParams {
  id: number;
  code: number;
}

export const sendPaymentAttribution = (params: SendAttributionParams): void => {
  fetch('https://peetsunbae.com/api/payments/track-attribution', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: params.id,
      code: params.code,
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      userAgent: navigator.userAgent,
    }),
  }).catch((error) => {
    console.error('[Payment Attribution] Failed:', error);
  });
};
